
 



import React from "react";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";

const products = [
  {
    id: 311,
    name: "3D Lawn with Lawn Dupatta 3 Piece A-2024 ",
    price: 2999,
    image: "/image/Ladies/A-2024.jpeg",
  },
  {
    id: 312,
    name: "Lawn Same Dupatta 3 Piece A-8340",
    price: 2999,
    image: "/image/Ladies/A-8340.jpeg",
  },
 {
    id: 313,
    name: "Lawn Same Dupatta 3 Piece A-8397",
    price: 2999,
    image: "/image/Ladies/A-8397.jpeg",
  },

 {
    id: 314,
    name: "Lawn Same Dupatta 3 Piece A-13210",
    price: 2999,
    image: "/image/Ladies/A-13210.jpeg",
  },
   {
    id: 315,
    name: "Lawn Same Dupatta 3 Piece A-15307",
    price: 2999,
    image: "/image/Ladies/A-15307.jpeg",
  },

 {
    id: 316,
    name: "Lawn Same Dupatta 3 Piece A-15357",
    price: 2999,
    image: "/image/Ladies/A-15357.jpeg",
  },

{
    id: 317,
    name: "Lawn Same Dupatta 3 Piece A-15397",
    price: 2999,
    image: "/image/Ladies/A-15397.jpeg",
  },

{
    id: 318,
    name: "Lawn Same Dupatta 3 Piece A-15402",
    price: 2999,
    image: "/image/Ladies/A-15402.jpeg",
  },


{
    id: 319,
    name: "Lawn Same Dupatta 3 Piece A-15403",
    price: 2999,
    image: "/image/Ladies/A-15403.jpeg",
  },

{
    id: 320,
    name: "Lawn Same Dupatta 3 Piece A-15411",
    price: 2999,
    image: "/image/Ladies/A-15411.jpeg",
  },
{
    id: 321,
    name: "Lawn Same Dupatta 3 Piece A-15423",
    price: 2999,
    image: "/image/Ladies/A-15423.jpeg",
  },

{
    id: 322,
    name: "Lawn Same Dupatta 3 Piece A-15428",
    price: 2999,
    image: "/image/Ladies/A-15428.jpeg",
  },
{
    id: 323,
    name: "Lawn Same Dupatta 3 Piece A-15507",
    price: 2999,
    image: "/image/Ladies/A-15507.jpeg",
  },
{
    id: 324,
    name: "Lawn Same Dupatta 3 Piece A-28951",
    price: 2999,
    image: "/image/Ladies/A-28951.jpeg",
  },

{
    id: 325,
    name: "Lawn Same Dupatta 3 Piece A-28979",
    price: 2999,
    image: "/image/Ladies/A-28979.jpeg",
  },
{
    id: 326,
    name: "Lawn Same Dupatta 3 Piece A-28979",
    price: 2999,
    image: "/image/Ladies/A-28979.jpeg",
  },

{
    id: 327,
    name: "Lawn Same Dupatta 3 Piece A-29011",
    price: 2999,
    image: "/image/Ladies/A-29011.jpeg",
  },
{
    id: 328,
    name: "Lawn Same Dupatta 3 Piece A-775332",
    price: 2999,
    image: "/image/Ladies/A-775332.jpeg",
  },


{
    id: 329,
    name: "Lawn Same Dupatta 3 Piece AE_245",
    price: 2999,
    image: "/image/Ladies/AE_245.jpeg",
  },

{
    id: 330,
    name: "Lawn Same Dupatta 3 Piece B-28985",
    price: 2999,
    image: "/image/Ladies/B-28985.jpeg",
  },

{
    id: 331,
    name: "Lawn Same Dupatta 3 Piece B-29009",
    price: 2999,
    image: "/image/Ladies/B-29009.jpeg",
  },


{
    id: 332,
    name: "Supreme Lawn-3 pieces-B-75356.",
    details: "This Supreme Lawn-3pieces-B-75356. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/B-75356.jpeg",
  },

{
    id: 333,
    name: "Supreme Lawn-3pieces-BW-2047.",
    details: "This Supreme Lawn-3pieces-BW-2047. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/BW-2047.jpeg",
  },
{
    id: 334,
    name: "Supreme Lawn-3pieces-BW-2048.",
    details: "This Supreme Lawn-3pieces-BW-2048. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/BW-2048.jpeg",
  },

{
    id: 335,
    name: "Supreme Lawn-3pieces-BW-2049.",
    details: "This Supreme Lawn-3pieces-FKV27. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/BW-2049.jpeg",
  },

{
    id: 336,
    name: "Supreme Lawn-3pieces-D-2005-I.",
    details: "This Supreme Lawn-3pieces-D-2005-I. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-2005-I.jpeg",
  },

{
    id: 337,
    name: "Supreme Lawn-3pieces-D-4286.",
    details: "This Supreme Lawn-3pieces-D-4286. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-4286.jpeg",
  },

{
    id: 338,
    name: "Supreme Lawn-3pieces-D-4992.",
    details: "This Supreme Lawn-3pieces-D-4992. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-4992.jpeg",
  },
  {
    id: 339,
    name: "Supreme Lawn-3pieces-D-9026-B.",
    details: "This Supreme Lawn-3pieces-D-9026-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-9026-B.jpeg",
  },
  {
    id: 340,
    name: "Supreme Lawn-3pieces-D-9030-B.",
    details: "This Supreme Lawn-3pieces-D-9030-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-9030-B.jpeg",
  },

{
    id: 341,
    name: "Supreme Lawn-3pieces-D-9032-A.",
    details: "This Supreme Lawn-3pieces-D-9032-A. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-9032-A.jpeg",
  },
  {
    id: 342,
    name: "Supreme Lawn-3pieces-D-9032-C.",
    details: "This Supreme Lawn-3pieces-D-9032-C. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-9032-C.jpeg",
  },
  {
    id: 343,
    name: "Supreme Lawn-3pieces-D-9032-D.",
    details: "This Supreme Lawn-3pieces-D-9032-D. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-9032-D.jpeg",
  },
{
    id: 344,
    name: "Supreme Lawn-3pieces-D-13185.",
    details: "This Supreme Lawn-3pieces-D-13185. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-13185.jpeg",
  },

{
    id: 345,
    name: "Supreme Lawn-3pieces-D-13450.",
    details: "This Supreme Lawn-3pieces-D-13450. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-13450.jpeg",
  },

{
    id: 346,
    name: "Supreme Lawn-3pieces-D-13469-A.",
    details: "This Supreme Lawn-3pieces-D-13469-A. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-13469-A.jpeg",
  },


{
    id: 347,
    name: "Supreme Lawn-3pieces-D-15013.",
    details: "This Supreme Lawn-3pieces-D-15013. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-15013.jpeg",
  },


{
    id: 348,
    name: "Supreme Lawn-3pieces-D-15044-A.",
    details: "This Supreme Lawn-3pieces-D-15044-A. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-15044-A.jpeg",
  },

{
    id: 349,
    name: "Supreme Lawn-3pieces-D-15050-C.",
    details: "This Supreme Lawn-3pieces-D-15050-C. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-15050-C.jpeg",
  },

{
    id: 350,
    name: "Supreme Lawn-3pieces-D-15272-C.",
    details: "This Supreme Lawn-3pieces-D-15272-C. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-15272-C.jpeg",
  },
{
    id: 351,
    name: "Supreme Lawn-3pieces-D-15365-B.",
    details: "This Supreme Lawn-3pieces-D-15365-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-15365-B.jpeg",
  },

{
    id: 352,
    name: "Supreme Lawn-3pieces with ciffion Dupatta-D-28916.",
    details: "This Supreme Lawn-3pieces-D-28916B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-28916.jpeg",
  },

{
    id: 353,
    name: "Supreme Lawn-3pieces with same Dupatta-D-28964-B.",
    details: "This Supreme Lawn-3pieces-D-28964-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-28964-B.jpeg",
  },
{
    id: 354,
    name: "Supreme Lawn-3pieces with same Dupatta-D-28978-B.",
    details: "This Supreme Lawn-3pieces-D-28978-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-28978-B.jpeg",
  },


  {
    id: 355,
    name: "Supreme Lawn-3pieces with same Dupatta-D-28983-B.",
    details: "This Supreme Lawn-3pieces-D-28983-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-28983-B.jpeg",
  },

 {
    id: 356,
    name: "Supreme Lawn-3pieces with same Dupatta-D-28987-B.",
    details: "This Supreme Lawn-3pieces-D-28987-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-28987-B.jpeg",
  },

 {
    id: 357,
    name: "Supreme Lawn-3pieces with same Dupatta-D-75333-B.",
    details: "This Supreme Lawn-3pieces-D-28987-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-75333-B.jpeg",
  },

 {
    id: 358,
    name: "Supreme Lawn-3pieces with same Dupatta-D-75341-A.",
    details: "This Supreme Lawn-3pieces-D-28987-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-75341-A.jpeg",
  },
{
    id: 359,
    name: "Supreme Lawn-3pieces with same Dupatta-D-75333-B.",
    details: "This Supreme Lawn-3pieces-D-28987-B. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-75333-B.jpeg",
  },


{
    id: 360,
    name: "Supreme Lawn-3pieces with same Dupatta-D-75341-A.",
    details: "This Supreme Lawn-3pieces-D-75341-A. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D-75341-A.jpeg",
  },

{
    id: 361,
    name: "Supreme Lawn-3pieces with same Dupatta-D292.",
    details: "This Supreme Lawn-3pieces-D-75341-A. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/D292.jpeg",
  },
  {
    id: 362,
    name: "Supreme Lawn-3pieces with same Dupatta-E-229.",
    details: "This Supreme Lawn-3pieces-E-229. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/E-229.jpeg",
  },
  
  {
    id: 363,
    name: "Supreme Lawn-3pieces with same Dupatta-E-245.",
    details: "This Supreme Lawn-3pieces-E-245. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/E-245.jpeg",
  },

{
    id: 364,
    name: "Supreme Lawn-3pieces with same Dupatta-E-252.",
    details: "This Supreme Lawn-3pieces-E-252. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/E-252.jpeg",
  },
  {
    id: 365,
    name: "Supreme Lawn-3pieces with same Dupatta-E-659.",
    details: "This Supreme Lawn-3pieces-E-659. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/E-659.jpeg",
  },
  {
    id: 366,
    name: "Supreme Lawn-3pieces with same Dupatta-Maria-B1.",
    details: "This Supreme Lawn-3pieces-Maria-B1. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/Maria-B1.jpeg",
  },
  {
    id: 367,
    name: "Supreme Lawn-3pieces with same Dupatta-SK-917 (2).",
    details: "This Supreme Lawn-3pieces-SK-917 (2). Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/SK-917 (2).jpeg",
  },

 {
    id: 368,
    name: "Supreme Lawn-3pieces with same Dupatta-Sk-932.",
    details: "This Supreme Lawn-3pieces-SK-917 (2). Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/Sk-932.jpeg",
  },
   {
    id: 369,
    name: "Supreme Lawn-3pieces with same Dupatta-Sk-1009.",
    details: "This Supreme Lawn-3pieces-Sk-1009. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/Sk-1009.jpeg",
  },
  {
    id: 370,
    name: "Supreme Lawn-3pieces with same Dupatta-Sk-1010.",
    details: "This Supreme Lawn-3pieces-Sk-1010. Set is a perfect blend of style and comfort. The vibrant colors and intricate patterns make it a must-have addition to your wardrobe. Whether you're attending a festive event or a casual gathering, this set will ensure you look your best.",
    price: 2999,
    image: "/image/Ladies/Sk-1010.jpeg",
  },

];

const Fashion = () => {


  const navigate = useNavigate();
  return (
    <>
          <TopBar />
          <Navbar />
     
    <div className="min-h-screen bg-slate-100">
     


        {/* Hero Section */}
         <div className="bg-gradient-to-r from-black via-gray-900 to-black text-white py-14">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-5xl font-bold mb-3">Fashion Store</h1>
            <p className="text-lg text-gray-300">
              Trending Styles, Premium Quality Clothing & Accessories
            </p>
          </div>
        </div>



      {/* Products Section */}
      <div className="max-w-7xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold mb-8 text-slate-800">
          Featured Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden group"
            >
              {/* Product Image */}
              <div className="h-64 bg-gray-50 p-4 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-full w-full object-contain group-hover:scale-105 transition duration-300"
                />
              </div>

              {/* Product Details */}
              <div className="p-5">
                <h3 className="text-lg font-semibold text-slate-800 line-clamp-2 min-h-[56px]">
                  {product.name}
                </h3>

                <div className="flex items-center justify-between mt-4">
                  <span className="text-2xl font-bold text-orange-600">
                    Rs {product.price.toLocaleString()}
                  </span>
                </div>

                {/* <button className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300">
                  Add to Cart
                </button> */}
                <button
                        onClick={() => navigate(`/product/${product.id}`)}
                        className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300"
                        >
                        View Details
                        </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
     </>
  );
};

export default Fashion;






